<template>
  <div>
        <neu-cards-slider-pricing class="section" :cards="cardsPricing" :cards2="cardsPricing2" :title="$t('block-8.title')" :iva="$t('block-8.iva')"></neu-cards-slider-pricing>
    </div>
</template>

<script>
import { BForm, BFormGroup, BFormInvalidFeedback, BFormInput, BAlert, BIconEyeSlash, BIconEye, BCol, BTabs, BTab, BButton, BNavbarBrand, BNavbarNav, BNavbar, BNavbarToggle, BCollapse, BNavItem } from 'bootstrap-vue'
import BaseCard from '@/components/base/ui/BaseCard'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import GeographyRepository from '@/repositories/GeographyRepository'
import { map } from 'lodash'
import FooterOpensalud from '@/components/public/footers/FooterOpensalud.vue'
import LangSelector from '../../base/LangSelector.vue'
import NeuCardsSlider2 from '../../base/ui/NeuCardsSlider2.vue'
import NeuCardsSliderPricing from '../../base/ui/NeuCardsSliderPricing.vue'
import NeuCardsSliderProfessionalsSelector from '../../base/ui/NeuCardsSliderProfessionalsSelector.vue'
import NavProfessionalButtons from '../../base/nav-professional-buttons.vue'
import LoginForm from '@/components/forms/LoginForm.vue'
import BaseModal from '@/components/base/BaseModal.vue'
import Dropdown from '@/components/base/dropdown/Dropdown.vue'
import layoutMixin from '@/mixins/layout.mixin'

export default {
  name: 'landing-professional-menu',
  mixins: [layoutMixin],
  components: {
    'base-dialog': () => import('@/components/base/BaseDialog'),
    'base-button': () => import('@/components/base/buttons/BaseButton'),
    'patient-signup-form': () => import('@/components/forms/PatientSignupForm'),
    'carousel': () => import('@/components/base/carousel/Carousel'),
    'carousel-slide': () => import('@/components/base/carousel/CarouselSlide'),
    BCol,
    BTabs,
    Dropdown,
    BTab,
    BButton,
    BNavbar,
    BNavItem,
    BNavbarBrand,
    BCollapse,
    BNavbarNav,
    BNavbarToggle,
    BaseCard,
    NeuCardsSliderPricing,
    Swiper,
    SwiperSlide,
    FooterOpensalud,
    LangSelector,
    NeuCardsSlider2,
    NeuCardsSliderProfessionalsSelector,
    NavProfessionalButtons,
    LoginForm,
    BaseModal,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    BFormInput,
    BAlert,
    BIconEyeSlash,
    BIconEye
  },
  data () {
    return {
      hover: false,
      signInVisible: false,
      signUpVisible: false,
      services: [
        {
          title: this.$t('professional'),
          link: '#dlgRegisterProfessional'
        },
        {
          title: this.$t('patient'),
          link: '#dlgRegisterPatient'
        },
        {
          title: this.$t('centre'),
          link: '#dlgRegisterCenter'
        }
      ],
      cardsPricing: [
        {
          title: this.$t('cardsPricing.title1'),
          priceTitle: '14,90€',
          text: '5 profesionales incluidos. 5€/mes por profesional adicional (máx. 260€/mes)',
          subtitle: this.$t('cardsPricing.subtitle'),
          priceSubtitle: '1,5%'
        }
      ],
      cardsPricing2: [
        {
          title: this.$t('cardsPricing.title2'),
          priceTitle: '29€',
          text: this.$t('cardsPricing.text2'),
          subtitle: this.$t('cardsPricing.subtitle'),
          priceSubtitle: '1,5%'
        }
      ]
    }
  },
  directives: {
    swiper: directive
  },
  methods: {
    goToProfessionalForm () {
      window.location = this.$helpers.getAppUrl('#dlgRegisterProfessional')
    },
    goToLogin () {
      window.location = this.$helpers.getAppUrl('#/login')
    },
    goTo360 () {
      window.location = this.$helpers.getAppUrl('opensalud360/empresas')
    },
    goToContactForm () {
      this.$router.push('opensalud360/contacto')
    },
    goToSection (section, duration = 500) {
      this.$scrollTo(`#${section}`, duration, {
        container: 'body',
        easing: 'ease-in',
        lazy: false,
        force: true,
        cancelable: true,
        onStart: function (element) {
          // scrolling started
        },
        onDone: function (element) {
          // scrolling is done
        },
        onCancel () {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      })
    }
  },
  mounted () {
    GeographyRepository.getStatesByCountry(28).then(response => {
      this.formOptions.provinces = map(response.data.sort((a, b) => this.$i18nHelpers.normalize(a.name).localeCompare(this.$i18nHelpers.normalize(b.name))), item => {
        const stateName = this.$i18nHelpers.normalize(item.name)
        return {
          value: stateName,
          label: stateName
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
  @import "static-appopensalud/css/public/views/opensalud_profesionales.scss";

  .access-btn{
    @media screen and (max-width: 768px) {
    color: #3238C4 !important;
    background-color: transparent !important;    
    }
  }

  /* .tick-mobile {
    @include mobile {
      margin-right:1.25rem;
    }
    @include tablets {
      margin-right:1.25rem !important;
    }
    @include desktop-sm {
      margin-right:1.25rem !important;
    }
  } */
  .btn-4all {
    span {
        color: #3238C4;font-weight:bold; border-color:white;font-size:1rem;
      }
    @include desktop {
      margin-left: 30%;
      height: 3rem;
      span {
        font-size:1.10rem;
      }
    }
    @include desktop-sm {
      margin-left: 30%;
    }
    @include tablets {
        margin-left: 30%;
    }
    @include mobile {
        margin-left: 0%;
        width: 19rem;
    }
  }

  .btn-end:hover{
    color: #eee;
    background-color: #3238C4;
    border-color: #3238C4;
    span {
      color: white !important;
    }
  }

  .nav-item {
    @include desktop {
      margin-right: 1rem;
    }

    @include media(mobile, tablets) {
      padding: 0rem;
    }
  }
  .lang-cnt {
    font-weight: bold;

    p {
          color: $blue;
           @include desktop {
       &:is(:last-child) {
        margin-right: 1rem;
      }&:is(:first-child) {
        margin-left: 1rem;
      }
        }
          @include mobile {
       padding: 0;
        }
    }
  }
  .no-mobile{
     @include media(mobile, tablets) {
      display: none;
    }
  }
  .container-hearth {
    background-color:#E4E4E4;
    position: absolute;
     @include desktop {
      text-align: center;
      color: white;
        }
   @include media(mobile, tablets) {
      display: none;
    }
}
  .centered-title {
     @include desktop {
        position: absolute;
        top: 45%;
        left: 50%;
         @media screen and (max-width: 1440px) {
        font-size:3rem !important;

    }
        transform: translate(-50%, -50%);
        }
        @include desktop-sm {
        position: absolute;
        top: 45%;
        font-size:2rem !important;
        left: 50%;
        transform: translate(-50%, -50%);
        }
        @include media(mobile, tablets) {
      display: none;
    }

}
  .centered-button {
    @include desktop {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
        }
        @include media(mobile, tablets) {
      display: none;
    }

}
  .neu-cards-slider2 {
    @include media(mobile, tablets) {
      .row {
        display: block;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;

        [class*="col-"] {
          display: inline-block;
          width: 100%;
        }
      }
    }


    .card-ctn2 {
      display: block;

      @include desktop {
        padding: 0 2rem;
      }
      @include desktop-sm {
        padding: 0 2rem;
      }
      @include tablets {
        padding: 0;
      }
      @include media(tablets, mobile) {
        padding-right: 4rem;
        padding-left: 4rem;
        padding-top: 4rem;
        padding-bottom: 2rem;
      }

      .neu-card {
        display: block;
            transition-duration: 9999999s;
            justify-content:center ;
        &:hover {
            @include desktop {
                padding: 5rem;
            }
            @include desktop-sm {
              padding: 0rem 5rem;
            }
      
      transition-duration: 999999999s;
      }
        @include desktop {
          padding: 5rem;
          height: 400px;
          width: 320px;
        }
        @include desktop-sm {
          padding: 0rem 5rem;
          height: 400px;
          width: 320px;
        }

        @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: none;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
      
    }
  }
   .app {
        display:flex;
        justify-content: center;
    }
    .carousel {
        position:relative;
        overflow: hidden;
        width:800px;
        height:500px;
        z-index:10;
    }
    .btn2 {
        padding:5px 10px;
        background-color:rgba(0,0,0,0.5);
        border:1px solid transparent;
        margin:5px 10px;
        color:#FFF;
        height:50px;
        width:50px;
        position:absolute;
        margin-top:-25px;
        z-index:2;
    }
    .btn:hover {
        cursor: pointer;
    }
    .btn:focus{
        outline:none;
    }
    .btn-next {
        top:50%;
        right:0;
    }
    .btn-prev {
           @include desktop {
            top:25%;
            right:103%;
        }

        @include desktop-sm {
            top:25%;
            right:103%; 
        }
         @include mobile {
          
        }
    }
    .carousel-slider {
        position:absolute;
    }
    .carousel-slider img {
        width:100%;
        height:100%;
    }

</style>


// WEBPACK FOOTER //
// src/components/views/opensalud/TarifasProfesionales.vue